import React, { memo } from 'react'
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-apollo-hooks'
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { ToursMapQuery, IToursMapQueryVariables, IToursMapQueryData, ICountry, ILocation, withAppStoreValue, IToursFilter } from '../../../store';
import { IAroundMe, INearByTour } from '../common';
import { MapView } from '../../../components';

interface IToursMapViewAppStoreProps {
    filter: IToursFilter
}

export const ToursMapViewCore = memo(withRouter((props: RouteComponentProps & IToursMapViewAppStoreProps) => {
    const { i18n: { languages: [language] } } = useTranslation()
    const { filter } = props
    const { country = undefined, location = undefined, filterByRegion = undefined, aroundMe = undefined, searchText = undefined, nearByTour = undefined } = props.location.state || {}

    const actualCountry = country as ICountry
    const actualLocation = location as ILocation
    const actualAroundMe = aroundMe as IAroundMe
    const actualSearchText = searchText as string
    const actualNearByTour = nearByTour as INearByTour
    
    let area = undefined
    if (actualNearByTour) {
        area = {
            center: {
                lat: actualNearByTour.tour.lat,
                lng: actualNearByTour.tour.lng
            },
            radius: actualNearByTour.distance
        }
    } else if (actualAroundMe) {
        area = {
            center: {
                lat: actualAroundMe.center.lat,
                lng: actualAroundMe.center.lng
            },
            radius: actualAroundMe.distance
        }
    }

    const { data } = useQuery<any, IToursMapQueryVariables, any>(ToursMapQuery, {
        variables: {
            where: {
                language,
                countryId: actualCountry ? actualCountry.id : undefined,
                locationId: !filterByRegion && actualLocation ? actualLocation.id : undefined,
                region: filterByRegion && actualLocation ? actualLocation.region : undefined,
                area,
                searchText: actualSearchText || undefined,
                exclude: actualNearByTour ? [actualNearByTour.tour.id] : undefined,
                ...filter
            }
        }
    })
    const tours = data ? (data as IToursMapQueryData).toursMap : []
    //console.log(data, loading)
    return (
        <>
            <MapView data={tours}/>
        </>
    )
}))

export const ToursMapView = withAppStoreValue<IToursMapViewAppStoreProps>(ToursMapViewCore, ['filter'])